/**
 * @format
 */

import { UPDATE_LIST_VISIBILITY } from '../actions';

export default (state, type, payload) => {
  switch (type) {
    case UPDATE_LIST_VISIBILITY: {
      const { workspace_id, list_id, isVisible } = payload;

      return {
        ...state,
        lists: {
          ...state.lists,
          [workspace_id]: {
            ...state.lists[workspace_id],
            [list_id]: {
              ...state.lists[workspace_id][list_id],
              isVisible,
            },
          },
        },
      };
    }

    default:
      return state;
  }
};
